import * as React from "react";
export function BaseballHeaderItem(props) {
    return (React.createElement("span", { className: `rj-sport-scoreboard__live-baseball-header-item rj-sport-scoreboard__live-baseball-header-item--${props.index}` }, props.text));
}
//# sourceMappingURL=BaseballHeaderItem.js.map